var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 11h20v2H2zM2 18h20v2H2zM2 4h20v2H2z"}));
}

Hamburger.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
